import { View } from "react-native";
import { Button } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

// height in px of the button, used to ensure content can scroll up tu button
export const FLOATING_BUTTON_HEIGHT = 64;

type Props = {
  text: string;
  mode?: "text" | "outlined" | "contained" | "elevated" | "contained-tonal";
  disabled?: boolean;
  loading?: boolean;
  onPress: () => void;
};

export default function FloatingButton({
  text,
  mode = "contained",
  disabled,
  loading,
  onPress,
}: Props) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("bottom-0 inset-x-0 absolute px-6 pb-8")}>
      <Button
        mode={mode}
        onPress={onPress}
        disabled={disabled}
        loading={loading}
      >
        {text}
      </Button>
    </View>
  );
}
